// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AccountSetupRecovery from './AccountSetupRecovery';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, authInitialized, accountReady, accountError, userAttributes } = useAuth();
  const location = useLocation();

  if (!authInitialized) {
    return <p role="status">Loading your account…</p>;
  }

  if (isAuthenticated) {
    if (accountReady === false) {
      if (accountError?.code === 'email_verification_required') return <Navigate to="/verify-email" replace state={{
        email: userAttributes?.email, signupSub: userAttributes?.sub,
        attributeVerification: true, returnTo: `${location.pathname}${location.search}`,
      }} />;
      return <AccountSetupRecovery />;
    }
    return children;
  }

  const next = `${location.pathname}${location.search}`;
  return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
};

export default ProtectedRoute;
